"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _EntitySearch = _interopRequireDefault(require("./EntitySearch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Relation extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleChange", (value, action) => {
      const {
        onChange
      } = this.props;
      onChange(value ? value.Id : null);
    });
  }
  render() {
    const {
      row,
      schema,
      value,
      editForm
    } = this.props;
    let elementBeingEdited = editForm ? row : null;
    const expanded = value ? row[schema.expanded] : null;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EntitySearch.default, {
      isMulti: false,
      entity: schema.entity,
      onChange: this.handleChange,
      defaultValue: expanded,
      elementBeingEdited: elementBeingEdited
    }));
  }
}
var _default = exports.default = Relation;
module.exports = exports.default;